import React from 'react';
import { Experiment, Variant } from '@americanexpress/one-experiments';
import clsx from 'clsx';
import HotelRoomTravelers from '../HotelRoomTravelers/HotelRoomTravelers';
import { HOMEPAGE_REDESIGN_EXPERIMENT } from '../../constants/globalConstants';
import HotelLocations from '../HotelLocations/HotelLocations';
import HotelDateRange from '../HotelDateRange/HotelDateRange';
import SearchButton from './SearchButton/SearchButton';
import styles from './HotelsSearchBody.scss';

const HotelsSearchBody = () => {
  const redesignContent = (
    <div className={`${styles.variantSearchRow} row margin-0 pad-lr-xs-down`}>
      <div className="margin-0 pad-0 col-xs-12 col-sm-6 pad-r-sm-up col-lg-3 pad-t-xs-down">
        <HotelLocations />
      </div>
      <div className="margin-0 pad-0 col-xs-12 col-sm-6 col-lg-3 pad-r-lg-up pad-t-xs-down">
        <HotelRoomTravelers />
      </div>
      <div className="flex flex-row flex-item-grow margin-0 col-sm-12 col-lg-6 pad-0 pad-t-md-down">
        <div className="flex-item-grow">
          <HotelDateRange />
        </div>
        <div className={clsx('border-t', styles.searchBtnWrapper)}>
          <SearchButton />
        </div>
      </div>
    </div>
  );

  return (
    <Experiment
      experimentName={HOMEPAGE_REDESIGN_EXPERIMENT}
      dimensionName="search_widget"
      defaultVariant="control"
    >
      <Variant variant="control">
        <div className="pad">
          <HotelRoomTravelers />
          <div className="row flex-align-end">
            <div className="col-xs-12 col-md-7 pad-1-b-sm-down pad-0-r-md-up col-xl-8">
              <HotelLocations />
            </div>
            <div className="col-xs-12 col-md-4 col-xl-3 pad-0-r pad-b-sm-down">
              <HotelDateRange />
            </div>
            <div className="col-md-1 col-xs-12 margin-b-sm-down pad-0-l-md-up">
              <SearchButton />
            </div>
          </div>
        </div>
      </Variant>
      <Variant variant="widget_a_with_hero">
        {redesignContent}
      </Variant>
      <Variant variant="widget_a_no_hero">
        {redesignContent}
      </Variant>
      <Variant variant="widget_b_with_hero">
        {redesignContent}
      </Variant>
      <Variant variant="widget_b_no_hero">
        {redesignContent}
      </Variant>
    </Experiment>
  );
};

export default HotelsSearchBody;
